module.exports = __webpack_public_path__ + "static/img/dlInspection.d599fb2c.png";